import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { emptyErrorState, emptyTimeSlots } from 'components/AvailabilityInput/availability-input.constants';
import axios from 'axios';
import AvailabilityInput from 'components/AvailabilityInput/AvailabilityInput';
import { getAvailabilities, parseError, validateAvailabilityTime } from 'utils/helpers';
import Completed from 'components/Base/Completed';
import DatePicker from 'components/DatePicker/DatePicker';
import moment from 'moment';

const JobReschedule = () => {
    const [title, setTitle] = useState('');
    const [providerId, setProviderId] = useState('')
    const [completed, setCompleted] = useState(false);
    const [providersOvernight, setProvidersOvernight] = useState(false);
    const [error, setError] = useState({
        type: '',
        message: '',
    });

    const [timeData, setTimeData] = useState({
        date: [],
        startTime: '',
        endTime: '',
        weeklyRepeat: false,
    })

    const [overnight, setOvernight] = useState(false)
    const [isOvernightValid, setIsOvernightValid] = useState(false);

    const [availabilitiesState, setAvailabilitiesState] =
        useState(emptyTimeSlots);
    const [availabilitiesErrorState, setAvailabilitiesErrorState] =
        useState(emptyErrorState);

    const navigate = useNavigate();
    const { id: jobId } = useParams();

    const submitJob = useCallback(async () => {
        setError({ type: '', message: '' });

        const body = {
            date: timeData.date,
            timeState: { startTime: timeData.startTime, endTime: timeData.endTime },
            weekly_repeat: timeData.weeklyRepeat || null,
            isOvernight: overnight
        };

        try {
            const { data } = await axios.patch(`/jobs/${jobId}/reschedule`, body);
            if (data) {
                setCompleted(true);
            }
        }
        catch (e) {
            setError(parseError(e));
        }
    }, [
        jobId,
        timeData,
        navigate,
        availabilitiesState,
        overnight
    ]);

    useEffect(() => {
        if (!jobId) return
        axios
            .get(`/jobs/${jobId}`)
            .then(({ data }) => {
                setTitle(data.title);
                setTimeData((prev) => ({ ...prev, date: data.date }))
            })
            .catch((e) => {
                navigate('/');
            });
    }, [jobId, navigate]);


    useEffect(() => {
        axios
            .get(`jobs/${jobId}/provider`)
            .then(({ data }) => {
                // setOvernight(data.isvernight)
                setProviderId(data._id)
                setProvidersOvernight(data.overnight)
            })
    }, [jobId])

    useEffect(() => {
        if (!providerId) return
        axios
            .get(`jobs/${jobId}/provider`)
            .then(({ data }) => {
                setProviderId(data._id)
                if (data.availabilities) {
                    setAvailabilitiesState(getAvailabilities(data))
                }
            })
            .catch((error) => {
                console.log(error)
            });
    }, [providerId, jobId]);

    const checkOvernightAvailability = () => {
        const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

        for (let i = 0; i < days.length; i++) {
            const currentDay = days[i];
            const nextDay = days[(i + 1) % days.length];

            const hasEndAtMidnight = availabilitiesState[currentDay]?.some(slot => slot.endTime === "23:59");
            const hasStartAtMidnight = availabilitiesState[nextDay]?.some(slot => slot.startTime === "00:00");
            if (hasEndAtMidnight && hasStartAtMidnight) {
                return true;
            }
        }
        return false;
    };

    useEffect(() => {
        setIsOvernightValid(checkOvernightAvailability());
    }, [timeData, checkOvernightAvailability]);

    return (
        <div className='page job-create'>

            <h1 className="page-title">Reschedule Job {title}</h1>

            <DatePicker
                providerId={providerId}
                availabilitiesState={availabilitiesState}
                timeData={timeData}
                setTimeData={setTimeData}
                overnight={overnight}
            />

            <h2>Overnight</h2>
            <label className="base-checkbox overnights">
                <input
                    type="checkbox"
                    checked={overnight}
                    onChange={(e) => setOvernight(e.target.checked)}
                    disabled={!isOvernightValid || !providersOvernight}
                />
                <div className="check"></div>
                <div className="base-label">
                    {providersOvernight
                        ? "Enable for overnight work"
                        : "Provider doesn't work overnight"}
                </div>
            </label>

            <div className="block availability">
                <AvailabilityInput
                    availabilities={availabilitiesState}
                    error={availabilitiesErrorState}
                    canEdit={false}
                />
            </div>
            <div className="error">
                <b>{error.type}</b>&nbsp;{error.message}
            </div>

            <button className="submit" onClick={submitJob}>
                Reschedule
            </button>


            <Completed redirect="/jobs/my" show={completed} setShow={setCompleted} />
        </div>
    )
}

export default JobReschedule
